import { useAuthGuardContext } from "~/route-guards/withAuthGuard";
import { useRecord } from "./useRecord";

export function useCurrentUserMentionFrequency() {
  const { currentUserId } = useAuthGuardContext();
  const [settings] = useRecord("user_settings", currentUserId);
  return [settings?.mention_frequency ?? null];
}
